import { render, staticRenderFns } from "./PermitLicenses.vue?vue&type=template&id=76777502&"
import script from "./PermitLicenses.vue?vue&type=script&lang=js&"
export * from "./PermitLicenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76777502')) {
      api.createRecord('76777502', component.options)
    } else {
      api.reload('76777502', component.options)
    }
    module.hot.accept("./PermitLicenses.vue?vue&type=template&id=76777502&", function () {
      api.rerender('76777502', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/company/components/PermitLicenses.vue"
export default component.exports